module.exports = __webpack_public_path__ + "img/sld_mppt_1_t1_b1_green.b46baa1d.svg";